export default class card {
  constructor(front,back,quizid){
    this.front = front;
    this.back = back;
    this.quizid=quizid;
  }

}
